// First-touch UTM attribution.
//
// On the visitor's first page load, stash any `?utm_*` params in
// sessionStorage. Subsequent client-side navigation preserves them, so a
// form submission from page 3 still carries the UTMs the visitor arrived
// with on page 1. Storage is session-scoped — closing the tab resets it.

const STORAGE_KEY = 'aakeeo_utm';
const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function captureUtmFromUrl() {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const incoming = {};
  let hasAny = false;
  UTM_FIELDS.forEach((k) => {
    const v = params.get(k);
    if (v) { incoming[k] = v; hasAny = true; }
  });
  if (!hasAny) return;
  try {
    // First-touch wins — don't overwrite if we already captured this session.
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(incoming));
    }
  } catch (e) { /* sessionStorage may be disabled */ }
}

export function readUtm() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}
